import { dispatchDisabledStateUpdate } from '@engine/actions/creators/async-select-multi';
import { options } from '@engine/features/apply_chosen';
var REACT_FILTERS = ['trx_fee_charged_on', 'interchange_charged_on', 'commission_rule_id'];
var TRX_WITH_PAYMENT_SUBTYPES = ['ApplePayTransaction', 'GooglePayTransaction'];

function hasAppliedChosen(selectedFilter) {
  return typeof $('#' + selectedFilter).data('chosen') !== 'undefined';
}

function transactionWithPaymentSubtype(selectedTransactionTypes) {
  return selectedTransactionTypes.filter(function (trn_type) {
    return TRX_WITH_PAYMENT_SUBTYPES.indexOf(trn_type) >= 0;
  });
}

function transactionWithPaymentType(selectedTransactionTypes) {
  return selectedTransactionTypes.filter(function (trn_type) {
    return TRX_WITH_PAYMENT_SUBTYPES.indexOf(trn_type) === -1;
  });
}

function toggleDisabledAttribute(selectedFilter) {
  var filterRow = $('.filter[data-filter="' + selectedFilter + '"]').toggleClass('hidden');

  if (REACT_FILTERS.includes(selectedFilter)) {
    return;
  }

  var filterInputs = $('input[type="text"]:not(.default), select', filterRow);
  var radioInputs = $('input[type="radio"]', filterRow);
  $.each(filterInputs, function (index, element) {
    var $element = $(element);
    $element.prop('disabled', function (i, disabled) {
      return !disabled;
    });

    if ($element.hasClass('for_chosen') && !hasAppliedChosen(selectedFilter)) {
      $element.chosen(options);
    }
  });
  $.each(radioInputs, function (index, element) {
    var $element = $(element);
    $element.prop('disabled', function (i, disabled) {
      return !disabled;
    });
  });
}

function addPaymentTypesToDropdown(typeField, paymentTypes) {
  $.each(paymentTypes, function (value, type) {
    var option = $('<option/>').attr('value', type).text(type);

    if ($('#' + typeField + " option[value=".concat(type, "]")).length === 0) {
      $('#' + typeField).append(option);
    }
  });
}

function updatePaymentTypesSelect(typesField, types) {
  var emptyValue = '<option value="">' + I18n.t('javascript.options.please_select') + '</option>';
  var $paymentTypesSelect = $('#' + typesField);

  if ($('.filter[data-filter="' + typesField + '"]').is(':hidden')) {
    toggleDisabledAttribute($paymentTypesSelect.attr('id'));
  }

  $paymentTypesSelect.append(emptyValue);
  addPaymentTypesToDropdown(typesField, types);
  $paymentTypesSelect.trigger('chosen:updated');
}

function handlePaymentTypesResponse(paymentTypesObject, withSubtype) {
  var availablePaymentTypes = paymentTypesObject.payment_types;
  var typesField = withSubtype ? 'payment_subtypes' : 'payment_types';
  var $paymentTypeSelect = $("#".concat(typesField));
  var $paymentTypeChosen = $("#".concat(typesField, "_chosen"));
  $paymentTypeSelect.empty();

  if (Array.isArray(availablePaymentTypes) && availablePaymentTypes.length) {
    updatePaymentTypesSelect(typesField, availablePaymentTypes);
  } else if ($paymentTypeChosen.is(':visible')) {
    toggleDisabledAttribute($paymentTypeSelect.attr('id'));
  }
}

function clearPaymentTypesDropdown(withSubtype) {
  var typesField = withSubtype ? 'payment_subtypes' : 'payment_types';
  var $paymentTypeSelect = $("#".concat(typesField));
  var $paymentTypeChosen = $("#".concat(typesField, "_chosen"));
  $paymentTypeSelect.empty();

  if ($paymentTypeChosen.is(':visible')) {
    toggleDisabledAttribute($paymentTypeSelect.attr('id'));
  }
}

function updatePaymentTypes(selectedTransactionTypes) {
  var withSubtype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  $.ajax({
    method: 'GET',
    url: '/payment_transactions/payment_types',
    dataType: 'json',
    contentType: 'application/json',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      selected_transaction_types: selectedTransactionTypes
    },
    success: function success(data) {
      handlePaymentTypesResponse(data, withSubtype);
    }
  });
} // Public


function listenForSearchFilterSelect() {
  var filterSelect = $('#add_filter');
  filterSelect.on('change', function () {
    var selectedOption = $('option:selected', filterSelect);
    var selectedFilter = selectedOption.val();
    toggleDisabledAttribute(selectedFilter);

    if (REACT_FILTERS.includes(selectedFilter)) {
      dispatchDisabledStateUpdate(false, selectedFilter);
    }

    selectedOption.prop('selected', false);
    filterSelect.trigger('chosen:updated');
  });
}

function listenForSearchFilterRemove() {
  $('.filter a.glyphicon-remove').on('click', function () {
    var selectedFilter = $(this).parents('.filter').data('filter');
    $(selectedFilter).toggleClass('hidden');
    toggleDisabledAttribute(selectedFilter);

    if (REACT_FILTERS.includes(selectedFilter)) {
      dispatchDisabledStateUpdate(true, selectedFilter);
    }
  });
}

function togglePaymentTypes() {
  var selectedTransactionTypes = $('#type').val();
  /**
   * jQuery 3.0 - select-multiple with nothing selected returns an empty array
   */

  if (Array.isArray(selectedTransactionTypes) && selectedTransactionTypes.length === 0) {
    return;
  }

  if (selectedTransactionTypes && selectedTransactionTypes.length) {
    var withPaymentSubtype = transactionWithPaymentSubtype(selectedTransactionTypes);
    var withPaymentType = transactionWithPaymentType(selectedTransactionTypes);
    updatePaymentTypes(withPaymentSubtype, true);
    updatePaymentTypes(withPaymentType);
  } else {
    clearPaymentTypesDropdown();
    clearPaymentTypesDropdown(true);
  }
}

function listenForTransactionTypeSelect() {
  $('#type').on('change', function () {
    togglePaymentTypes();
  });
}

function showPopulatedFilters() {
  var filterInputs = $('input[type="text"]:not(.double-toggle), ' + 'select.for_select');
  var checkedRadioInputs = $('.filter.radio-group input[type="radio"]:checked');
  filterInputs.each(function () {
    var value = $(this).val();
    /**
     * jQuery 3.0 - select-multiple with nothing selected returns an empty array
     */

    if (Array.isArray(value) && value.length === 0) {
      return;
    }

    if (value !== null && value !== '') {
      var selectedFilter = $(this).parents('.filter').data('filter');
      toggleDisabledAttribute(selectedFilter);
    }
  });
  checkedRadioInputs.each(function () {
    if ($(this).val() !== '') {
      var selectedFilter = $(this).parents('.filter').data('filter');
      toggleDisabledAttribute(selectedFilter);
    }
  });
}

export { showPopulatedFilters, listenForSearchFilterSelect, listenForSearchFilterRemove, listenForTransactionTypeSelect };